import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../Translations';

function EmptyLicenseInsights() {
  return (
    <Typography variant="bodyMedium" color="dark">
      <T kind="License insights will appear here once they are available." />
    </Typography>
  );
}

export default observer(EmptyLicenseInsights);
